const BASE_KEYS = {
  loan: 'loan',
  cash: 'cash',
  fundraising: 'fundraising',
  user: 'user',
  brand: 'brand',
  common: 'common',
  reporting: 'reporting',
  activity: 'activity',
  dashboard: 'dashboard',
  chatwoot: 'chatwoot',
  compliance: 'compliance',
};

export const QUERY_KEYS = {
  dashboard: {
    lender_stats: `${BASE_KEYS.dashboard}_lender_stats`,
    partners_count: `${BASE_KEYS.dashboard}_partners_count`,
  },
  loan: {
    list: `${BASE_KEYS.loan}_list`,
    refin_banner_status: `${BASE_KEYS.loan}_refin_banner_status`,
    refin_available_loans: `${BASE_KEYS.loan}_refin_available_loans`,
    fpg_list: `${BASE_KEYS.loan}_fpg_list`,
    payment_schedule: `${BASE_KEYS.loan}_payment_schedule`,
    lender_loan_list: `${BASE_KEYS.loan}_lender_loan_list`,
    lender_loan_detail: `${BASE_KEYS.loan}_lender_loan_detail`,
  },
  cash: {
    balance: `${BASE_KEYS.cash}_balance`,
    next_repayment: `${BASE_KEYS.cash}_next_repayment`,
    repayment_schedule: `${BASE_KEYS.cash}_repayment_schedule`,
    repayment_detail_deadline: `${BASE_KEYS.cash}_repayment_detail_deadline`,
    dashboard_balance: `${BASE_KEYS.cash}_dashboard_balance`,
    dashboard_payment_info: `${BASE_KEYS.cash}_dashboard_payment_info`,
    bank_statements: `${BASE_KEYS.cash}_bank_statements`,
  },
  fundraising: {
    status: `${BASE_KEYS.fundraising}_status`,
    status_by_id: `${BASE_KEYS.fundraising}_status_by_id`,
    risk_factor_status: `${BASE_KEYS.fundraising}_risk_factor_status`,
    co_founders_list: `${BASE_KEYS.fundraising}_co_founders_list`,
    tariff_plans: `${BASE_KEYS.fundraising}_tariff_plans`,
    recalculation: `${BASE_KEYS.fundraising}_recalculation`,
    fundraising_dates: `${BASE_KEYS.fundraising}_fundraising_dates`,
    next_status: `${BASE_KEYS.fundraising}_next_status`,
    application_by_fundraising_id: `${BASE_KEYS.fundraising}_application_by_fundraising_id`,
    application_status_by_id: `${BASE_KEYS.fundraising}_application_status_by_id`,
    application_list: `${BASE_KEYS.fundraising}_application_list`,
    founder_fr_status: `${BASE_KEYS.fundraising}_founder_fr_status`,
    lender_applications: `${BASE_KEYS.fundraising}_lender_applications`,
    lender_fr_status_by_company_id: `${BASE_KEYS.fundraising}_lender_fr_status_by_company_id`,
  },
  user: {
    profile: `${BASE_KEYS.user}_profile`,
    my_location: `${BASE_KEYS.user}_my_location`,
    phone_verify: `${BASE_KEYS.user}_phone_verify`,
  },
  brand: {
    detail_by_slug: `${BASE_KEYS.brand}_detail_by_slug`,
  },
  common: {
    countries: `${BASE_KEYS.common}_countries`,
  },
  reporting: {
    status: `${BASE_KEYS.reporting}_status`,
    modes: `${BASE_KEYS.reporting}_modes`,
    pending_reports: `${BASE_KEYS.reporting}_pending_reports`,
    submitted_reports: `${BASE_KEYS.reporting}_submitted_reports`,
    detail: `${BASE_KEYS.reporting}_detail`,
  },
  activity: {
    activity_types: `${BASE_KEYS.activity}_activity_types`,
    cash_movements: `${BASE_KEYS.activity}_cash_movements`,
    portfolio_movemennts: `${BASE_KEYS.activity}_portfolio_movements`,
    tax_report: `${BASE_KEYS.activity}_tax_report`,
  },
  chatwoot: {
    identity: `${BASE_KEYS.chatwoot}_identity`,
  },
  compliance: {
    notifications: `${BASE_KEYS.compliance}_notifications`,
    detail: `${BASE_KEYS.compliance}_detail`,
  },
};
